import type { CallTrackingResponse, State } from '../../typings'

export const fetchCallTrackingDetailsProducer = (
  state: State,
  payload: CallTrackingResponse,
): State => ({
  ...state,
  callTrackingDetails: payload,
})
